let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("dP9up")]).then(() => parcelRequire('9ZpIV'));